import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { TrackingItem, TrackingType } from '@stylehaven/components';
import { TrackingProvider } from '../entities/tracking-provider.entity';
import { TrackingProviderService } from '../services/_base-tracking-provider.service';
import { GoogleAnalyticsService } from '../services/google-analytics/google-analytics.service';

@Injectable()
export class TrackingSandbox {
    private readonly trackingProviderServices: TrackingProvider[];

    constructor(
        private readonly router: Router,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.trackingProviderServices = [
            {
                type: TrackingType.GA,
                service: this.googleAnalyticsService
            }
        ];
    }

    public initTracking(allTrackingItems: TrackingItem[] | undefined): void {
        if (allTrackingItems && allTrackingItems.length > 0) {
            this.initProviders(allTrackingItems);
        }
    }

    private initProviders(allTrackingItems: TrackingItem[]): void {
        for (const provider of this.trackingProviderServices) {
            this.initProvider(provider, allTrackingItems);
        }
    }

    private initProvider(provider: TrackingProvider, allTrackingItems: TrackingItem[]): void {
        const trackingItems: TrackingItem[] = allTrackingItems.filter(
            (item: TrackingItem) => item.type === provider.type
        );

        if (trackingItems.length > 0) {
            provider.service.init(trackingItems);
            this.trackPageViewsForProvider(provider.service);
        }
    }

    private trackPageViewsForProvider(service: TrackingProviderService): void {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                service.registerPageView(event.urlAfterRedirects);
            }
        });
    }
}
